import { ReactElement } from 'react';

import { getCustomFormattingContext, priceFormatter } from '@dreryk/react-common';
import { TestableComponentProps } from '@dreryk/react-components';

import { StyledPriceText } from './PriceTextView.styled';

type PriceTextViewProps = TestableComponentProps & {
   readonly value: number;
};

export const PriceTextView = (props: PriceTextViewProps): ReactElement => {
   return (
      <StyledPriceText testId={props.testId} whiteSpaces={'nowrap'}>
         {priceFormatter(props.value, getCustomFormattingContext({ options: { currency: 'PLN' } }))}
      </StyledPriceText>
   );
};
